import { AddAPhotoOutlined } from '@mui/icons-material'
import { Box, Grid, Typography, useTheme } from '@mui/material'

import classes from './index.styles'

const DropzoneOverlay = ({ isDragActive }: { isDragActive: boolean }) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        ...classes.dropzoneOverlay(theme),
        visibility: isDragActive ? 'visible' : 'hidden',
      }}
    >
      <Grid container={true} sx={classes.dropzone}>
        <AddAPhotoOutlined sx={classes.dropzoneIcon} />
        <Typography variant="subtitle1" sx={classes.dropzoneText}>
          Drop photo to upload
        </Typography>
        <Typography variant="caption" sx={classes.dropzoneText}>
          JPG, PNG, or GIF
        </Typography>
      </Grid>
    </Box>
  )
}

export default DropzoneOverlay
